import { useRef } from "react";
import { motion, useScroll, useReducedMotion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { PROCESS } from "@/data/site";

const ProcessTimeline = ({ dark = true }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.7", "end 0.6"] });

  return (
    <div ref={ref} data-testid="process-timeline" className="relative mt-16 lg:mt-24">
      <div className={`absolute left-[19px] lg:left-1/2 top-0 bottom-0 w-px ${dark ? "bg-white/10" : "bg-navy/10"}`} aria-hidden="true" />
      <motion.div
        className="absolute left-[19px] lg:left-1/2 top-0 bottom-0 w-px bg-electric origin-top"
        style={{ scaleY: reduce ? 1 : scrollYProgress }}
        aria-hidden="true"
      />
      <div className="flex flex-col gap-16 lg:gap-24">
        {PROCESS.map((step, i) => (
          <div key={step.num} className={`relative grid grid-cols-[40px_1fr] lg:grid-cols-2 gap-6 lg:gap-24 items-start`}>
            <div
              className={`absolute left-0 lg:left-1/2 top-1 lg:-translate-x-1/2 w-10 h-10 rounded-full border flex items-center justify-center font-display text-xs font-bold ${
                dark ? "bg-navy-deep border-electric/40 text-electric" : "bg-mist border-brand/40 text-brand"
              }`}
            >
              {step.num}
            </div>
            <Reveal
              className={`col-start-2 ${i % 2 === 0 ? "lg:col-start-1 lg:text-right lg:pr-4" : "lg:col-start-2 lg:pl-4"}`}
              delay={0.05 * i}
            >
              <h3 className={`font-display text-2xl lg:text-4xl font-extrabold tracking-tight ${dark ? "text-mist" : "text-navy"}`}>
                {step.title}
              </h3>
              <p className={`mt-3 leading-relaxed max-w-md ${i % 2 === 0 ? "lg:ml-auto" : ""} ${dark ? "text-slatec" : "text-navy/70"}`}>
                {step.text}
              </p>
            </Reveal>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessTimeline;
